/* eslint-disable */
<template>
  <section
    v-loading="isLoading"
  >
    <div class="container">
      <slot name="navigator" />
      <div class="row">
        <div class="page-content__image mb-3 mb-lg-0 col-12 col-lg-4">
          <div class="image-wrapper position-relatve">
            <div class="image-wrapper__top d-flex justify-content-between align-items-center px-3">
              <svg
                class="stroke"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 462 136.2"
              >
                <path
                  :class="getClass()"
                  d="M315.5-134.8c-4.5,1-10.9,1.3-68.4,2.8-40,1-40.4,1-42.3-1-1.7-1.8-2.1-1.9-4.6-.6-2.6,1.4-8.6,2-46.7,5-9.9.7-20.7,2.1-24,2.9-10.1,2.7-45.8,1.5-52.8-1.7-9.7-4.5-29-6.6-60.4-6.6H0v33.5C0-82.1.3-67,.6-67a13.529,13.529,0,0,0,2.5-1c2.3-1.3,2.5-.2.2,1.5C1.4-65.1,2.4-63,5-63c2.3,0,3.7,2,2,3-.8.5-.6.9.8,1.2a4.149,4.149,0,0,1,2.4,3.2c.5,2.2-.1,2.9-4,5.1A23.018,23.018,0,0,1,.9-48C.4-48,0-44.7,0-40.7c0,7,.1,7.4,3.5,10.7,3.9,3.7,4.3,6.5,2.3,13.3-1.1,3.5-1,4.1.6,5.3C8.8-9.7,7.8-7,4.7-7,1.7-7,0-5.2,0-2.2V.2L36.2-.4c20-.3,50.4-.9,67.7-1.2,25.5-.5,31.5-.4,32.2.7.6,1.1,1.7,1.1,5.6.1,2.6-.6,15.9-1.6,29.4-2.2,13.5-.5,27-1.5,30-2.2,7.8-1.9,45.1-1.4,51,.6C263.7-.7,268.2-.5,348.5-.5c42.9,0,86-.4,95.8-.9L462-2.2V-136l-71.2.1C350.6-135.8,317.8-135.4,315.5-134.8Z"
                  transform="translate(0 136)"
                />
              </svg>
              <h4 class="position-relative">{{ surrounding.name }}</h4>
              <div
                v-if="branche.id !== null"
                class="position-relative"
              >
                <i
                   :class="newsPostableType === 'DotNews' ? 'enjoj-nieuwsnl' : brancheIcon(branche.id)"
                   style="color: #fff; font-size: 1.8em;"
                ></i>
              </div>
            </div>
            <img
              :src="image"
              :alt="title"
              class="img-fluid"
            />
          </div>
        </div>
        <div
          class="page-content__text col-12 col-md-6 col-lg-5 mb-4 mb-md-0"
        >
          <ec-summery-article
            v-if="newsPostableType === 'Summary'"
            :title="title"
            :posts="newsPostable.data.posts.data"
            :subTitle="message"
          />
          <ec-article v-else
            :isEvent="isEvent"
            :address="address"
            :startDate="startDate"
            :endDate="endDate"
            :title="title"
            :message="message"
            :published="published"
            :cover="image"
            :media="media"
            :newsPostable="newsPostable"
            :newsPostableType="newsPostableType"
            :surrounding="surrounding"
          />
        </div>

        <div
          class="page-content__surrounding col-12 col-md-6 col-lg-3"
        >
          <div class="block p-3 mb-3">
            <h3
              v-if="isEvent"
              class="mb-3">
              <i class="fa fa-map-marker"></i> Waar?
            </h3>
            <h3
              v-else
              :class="'mb-3'">
              {{ surrounding.name }}
            </h3>
            <ul class="mb-3">
              <li class="mb-1">{{ address.street + ' ' + address.housenumber }}</li>
              <li class="mb-1">{{ address.postalcode }}</li>
              <li>{{ address.city }}</li>
            </ul>
            <ul>
              <li
                v-if="surrounding.phonenumber"
                class="mb-1"
              >
                <i class="fa fa-phone"></i>
                <a
                  :href="'tel:' + surrounding.phonenumber"
                  class="text-decoration-none text-dark"
                >
                  {{ surrounding.phonenumber }}
                </a>
              </li>
              <li v-if="surrounding.email">
                <i class="fa fa-envelope"></i>
                <a
                  :href="'mailto:' + surrounding.email"
                  class="text-decoration-none text-dark"
                >
                  {{ surrounding.email }}
                </a>
              </li>
            </ul>
          </div>
          <div
            v-if="surrounding.is_demo === false && newsPostableType !== 'DotNews'"
            class="block modules p-3 mb-3"
          >
            <el-button
              type="primary"
              size="small"
              class="w-100 mb-2"
              round
              @click="handleClick(surrounding.id)"
            >
              Bekijk onze app
            </el-button>
            <el-button
              :class="modules.length ? 'mb-3' : ''"
              size="small"
              class="w-100"
              @click="$router.push({ name: 'business.index', params: { slug: kebab(surrounding.name) + '-' + surrounding.id } })"
              round>
              <span class="d-inline d-lg-none d-xl-inline">Naar de </span>bedrijvengids
            </el-button>
            <div
              v-if="modules.length"
            >
              <h4 class="mb-3">
                O.a. voorzien van:
              </h4>
              <ul>
                <li
                  v-for="(module, index) in activeModules"
                  :key="module"
                  :class="modules.length !== index ? 'mb-2' : ''"
                  class="module-item"
                >
                  <i class="fa fa-check text-success"></i>&nbsp;&nbsp;{{ module }}
                </li>
              </ul>
            </div>
          </div>
          <GmapMap
            v-if="isEvent && address.gps !== undefined"
            ref="maps"
            :key="id"
            :center="{ lat: address.gps.lat, lng: address.gps.lng }"
            :zoom="11"
            class="maps"
            :options="{
              mapTypeControl: false,
              zoomControl: false,
              streetViewControl: false,
              fullscreenControl: false,
              styles
            }"
          >
            <GmapMarker
              :position="{ lat: address.gps.lat, lng: address.gps.lng }"
            ></GmapMarker>
          </GmapMap>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapState } from 'vuex'
import mapStyle from '@/assets/mapStyle.json'
import Branche from '@/mixins/Branche'
import Distance from '@/mixins/Distance'
import Utilities from '@/mixins/Utilities'
import ecArticle from '@/components/General/Article'
import ecSummeryArticle from '@/components/General/SummaryArticle'

export default {
  name: 'ec-page-content',
  components: {
    ecArticle,
    ecSummeryArticle
  },
  mixins: [Branche, Distance, Utilities],
  props: {
    address: {
      type: Object,
      default () {
        return {
          city: '',
          housenumber: '',
          postalcode: '',
          street: ''
        }
      }
    },
    branche: {
      type: Object,
      default () {
        return {
          id: null
        }
      }
    },
    endDate: {
      type: String,
      default: ''
    },
    gps: {
      type: Object,
      default () {
        return {}
      }
    },
    id: {
      type: Number,
      default: null
    },
    image: {
      type: String,
      default: ''
    },
    isEvent: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    modules: {
      type: Array,
      default () {
        return []
      }
    },
    newsPostable: {
      type: Object,
      default () {
        return {}
      }
    },
    newsPostableType: {
      type: String,
      default: ''
    },
    published: {
      type: String,
      default: ''
    },
    startDate: {
      type: String,
      default: ''
    },
    surrounding: {
      type: Object,
      default () {
        return {}
      }
    },
    title: {
      type: String,
      default: ''
    },
    media: {
      type: Object,
      default () {
        return {
          data: []
        }
      }
    }
  },
  data () {
    return {
      isLoading: false,
      galleryImages: [],
      galleryIndex: null,
      styles: mapStyle
    }
  },
  computed: {
    ...mapState([
      'eventLoader'
    ]),
    activeModules () {
      let modules = []
      this.modules.forEach((module) => {
        if (module !== 'Statistieken' && module !== 'Loyaliteit' && module !== 'Push') {
          modules.push(module)
        }
        if (module === 'Push') {
          modules.push('Notificaties')
        }
        if (module === 'Loyaliteit') {
          modules.push('Spaarprogramma')
        }
      })

      return modules
    },
    resource () {
      if (!_.isEmpty(this.newsPostable)) {
        let url = '<a target="_blank" href="' + this.newsPostable.data.source_url + '">'
        let closingTag = '</a>'
        let source

        switch (this.newsPostableType) {
          case 'Summary':
          case 'Custom':
            source = 'Enjoj'
            url = ''
            closingTag = ''
            break
          case 'DotNews':
            source = this.surrounding.name + ' - Nieuws.nl'
            break
          case 'RSS':
            source = 'RSS'
            url = ''
            closingTag = ''
            break
          case 'Facebook':
            source = 'Facebook'
            break
        }
        url += source + closingTag

        return url
      }
      return ''
    }
  },
  watch: {
    eventLoader (condition) {
      this.isLoading = condition
    },
    newsPostable (item) {
      this.renderImages(item.data.media.data)
    }
  },
  methods: {
    getClass () {
      let id = 0
      if (this.branche.id !== null) {
        id = this.branche.id
      }
      return 'stroke-' + id
    },
    getDate () {
      moment.locale('nl')
      if (this.published) {
        let published = moment(this.published, 'YYYY-MM-DD hh:mm:ss').format('LLL')

        return published
      } else if (this.isEvent) {
        let startDate = moment(this.startDate, 'YYYY-MM-DD hh:mm:ss').format('LL')
        let startTime = moment(this.startDate, 'YYYY-MM-DD hh:mm:ss').format('HH:mm')

        let endDate = moment(this.endDate, 'YYYY-MM-DD hh:mm:ss').format('LL')
        let endTime = moment(this.endDate, 'YYYY-MM-DD hh:mm:ss').format('HH:mm')
        let time = startDate + ' - ' + startTime + ' | ' + endDate + ' - ' + endTime

        if (startDate === endDate) {
          time = startTime + ' - ' + endTime
          return startDate + ' | ' + time
        }

        return time
      }
      return ''
    },
    handleClick (id) {
      let tab = window.open('https://beta.enjoj-test.nl/community/surrounding/' + id, '_blank')
      tab.focus()
    },
    parseHtml (message) {
      message = message.replace(/href=" /g, 'href="')

      if (this.newsPostableType === 'Facebook') {
        message = this.urlify(message)
      }

      let wrapper = document.createElement('p')
      wrapper.innerHTML = message

      if (this.newsPostableType === 'DotNews') {
        let paragraphs = wrapper.querySelectorAll('p')
        for (let i = 0; i < paragraphs.length; i++) {
          if (paragraphs[i].innerHTML === '<br>') {
            paragraphs[i].classList.add('d-none')
          }
        }
      }

      return wrapper.innerHTML
    },
    renderImages (items) {
      return items.filter(item => item.type === 'image')
    },
    renderVideos (items) {
      return items.filter(item => item.type === 'video')
    },
    urlify (text) {
      text = text.replace(/href="www/g, 'href="http://www')
      let newText = (text || '').replace(/\S+[a-z0-9]@[a-z0-9.]+/, (match) => {
        let email = match
        return '<a href="mailto:' + email + '">' + email + '</a>'
      })

      return (newText || '').replace(/([^\S]|[(]|^)(((https?:\/\/)|(www\.))(\S+))/gi, (match, space, url) => {
        let hyperlink = url.replace(').', '').replace(')', '').replace('(', '')
        if (!hyperlink.match('^https?://')) {
          hyperlink = 'http://' + hyperlink
        }
        return space + '<a target="_blank" href="' + hyperlink + '">' + url + '</a>'
      })
    }
  }
}
</script>
